module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo9-fc8ad1d8153661aa1b996a8d53a6a789.jpg";